<template>
  <div>
    <div class="campaign-create-condition">
      <Panel>
        <div class="condition-header">
          <span class="condition-title">キャンペーンタイプ</span>
        </div>

        <div class="campaign-type-or-entry-action">
          <el-select :value="form.campaign_type" @change="changeCampaignType" :disabled="is_campaign_type_disabled">
            <el-option
              v-for="(option, index) in campaign_type_options"
              :key="index"
              :value="option.value"
              :label="option.label"
            />
          </el-select>
        </div>

        <div class="condition-description">TikTok上で応募が完結する、後日抽選のキャンペーンです。</div>

        <div class="campaign-type-or-entry-action condition-header">
          <span class="condition-title">応募条件</span>
        </div>

        <div class="campaign-type-or-entry-action">
          <el-select :value="form.entry_action_type" @change="changeEntryActionType" :disabled="is_condition_disabled">
            <el-option
              v-for="(option, index) in entry_action_type_options"
              :key="index"
              :value="option.value"
              :label="option.label"
            />
          </el-select>
        </div>

        <div class="condition-description">特定のハッシュタグを含む実施アカウントの投稿に対するコメント</div>

        <div class="condition-image">
          <img src="@/client/assets/images/tiktok_condition_comment.png" />
        </div>
      </Panel>
    </div>
    <div class="campaign-create-condition">
      <Panel>
        <div class="condition-header">
          <span class="condition-title">キャンペーンハッシュタグ</span>
          <span class="badge badge-danger">必須</span>
        </div>

        <div class="condition-description">キャンペーンを判別するためのハッシュタグを入力してください</div>

        <div class="condition-keywords">
          <Tags
            :value="keywords"
            :editable="!is_condition_disabled"
            :max-length="120"
            @input="changeKeywords"
            :sns-type="'tiktok'"
          />
        </div>

        <div class="condition-description">
          <div class="description-danger">応募の振り分けについて</div>
          応募の振り分けをする場合、キャンペーン作成後に応募グループを追加する必要があります。
        </div>
      </Panel>
    </div>
  </div>
</template>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { mapActions, mapState } from 'pinia'
import { isValidHashtag } from 'twitter-text'
import { defineComponent } from 'vue'

import Panel from '@/client/components/_atoms/Panel.vue'
import Tags from '@/client/components/_molecules/Tags.vue'
import {
  TIKTOK_CAMPAIGN_TYPES_OPTIONS,
  TIKTOK_ENTRY_ACTION_TYPES_OPTIONS,
  TIKTOK_ENTRY_ACTION_TYPES
} from '@/client/constant'
import { CAMPAIGN_STATUS } from '@/client/constant'
import { TrackingService } from '@/client/services'
import { useCampaignDialogStore } from '@/client/store/useCampaignDialogStore'
export default defineComponent({
  components: {
    Panel,
    Tags
  },
  methods: {
    ...mapActions(useCampaignDialogStore, ['setForm']),
    async changeCampaignType(value: string) {
      const form = {
        ...this.form,
        campaign_type: value
      }

      await this.setForm(form)
    },
    async changeEntryActionType(value: string) {
      const form = {
        ...this.form,
        entry_action_type: value
      }

      await this.setForm(form)
    },
    async changeKeywords(value: string[]) {
      if (this.form.keywords?.length < value.length) {
        TrackingService.sendEvent('click:キャンペーンの新規作成|応募条件(TikTok)|全てを含む|追加')
      } else TrackingService.sendEvent('click:キャンペーンの新規作成|応募条件(TikTok)|全てを含む|削除')

      const is_valid = this.checkoutValidKeyword(value)

      if (!is_valid) {
        return
      }

      const form = {
        ...this.form,
        keywords: value
      }

      await this.setForm(form)
    },
    checkoutValidKeyword(keywords: string[]) {
      const is_valid = keywords.every(keyword => isValidHashtag(keyword))

      if (!is_valid) {
        this.$notify({
          title: 'ハッシュタグに利用できない文字列が含まれています。',
          message: '',
          customClass: 'danger'
        })
      }

      return is_valid
    }
  },
  created() {
    const form = {
      ...this.form,
      campaign_type: 'keyword',
      entry_action_type: TIKTOK_ENTRY_ACTION_TYPES.value
    }

    this.setForm(form)
  },
  computed: {
    ...mapState(useCampaignDialogStore, ['form', 'api_campaign', 'mode']),
    campaign_type_options() {
      return TIKTOK_CAMPAIGN_TYPES_OPTIONS
    },
    entry_action_type_options() {
      return TIKTOK_ENTRY_ACTION_TYPES_OPTIONS
    },
    is_campaign_type_disabled() {
      return this.mode === 'edit'
    },
    is_condition_disabled() {
      return (
        this.api_campaign &&
        [CAMPAIGN_STATUS.DURING_FINAL_COLLECTION, CAMPAIGN_STATUS.COLLECTION_COMPLETED].includes(
          this.api_campaign.status
        ) &&
        this.mode === 'edit'
      )
    },
    keywords() {
      return this.form.keywords
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.campaign-create-condition {
  margin-top: $spacing-unit * 2;
}

.campaign-type-or-entry-action {
  margin-top: $spacing-unit;
}

.condition-description {
  margin-top: $spacing-unit;
  font-size: $font-small-size;
  color: $sub-text-color;
}

.condition-image {
  margin-top: $spacing-unit;
  text-align: center;
  border: 1px solid $border-color;
  border-radius: 4px;

  img {
    max-width: $spacing-unit * 60;
  }
}

.condition-header {
  .condition-title {
    font-weight: bold;
  }

  .badge {
    margin-left: $spacing-unit;
  }
}

.description-danger {
  color: $danger-color;
}

.condition-keywords {
  margin-top: $spacing-unit;
}
</style>
